import React, { useState } from "react"
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Modal,
  ModalBody,
  ModalFooter,
  Button,
  FormFeedback,
  Input,
} from "reactstrap"
import { Link, useLocation } from "react-router-dom"
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"

//i18n
import { withTranslation } from "react-i18next"

// Formik Validation
import * as Yup from "yup"
import { useFormik } from "formik"

import moment from "moment"
import Snackbars from "../../Utils/Snackbars"
import useRequests from "../../Utils/useRequests"

const Property_Documents = props => {
  //meta title
  document.title = "Property Documents"
  const location = useLocation()
  const { getRequest, postRequest, postRequestByFormData } = useRequests()

  const [AlertData, setAlertData] = React.useState({
    variant: "",
    message: "",
  })
  const resetAlertData = () => {
    setTimeout(() => {
      setAlertData(AlertData => ({
        ...AlertData,
        variant: "",
        message: "",
      }))
    }, 5000)
  }

  const validation1 = useFormik({
    enableReinitialize: true,

    initialValues: {
      document_name: "",
    },
    validationSchema: Yup.object({
      document_name: Yup.string().required("Please enter document name"),
    }),
    onSubmit: async values => {
      try {
        if (fileName === "") {
          setAlertData(AlertData => ({
            ...AlertData,
            variant: "error",
            message: "Please select a document!",
          }))
          resetAlertData()

          return false
        } else {
          let submit1 = document.getElementById("submit1")
          submit1.disabled = true
          submit1.textContent = "Processing..."

          const formData = new FormData()
          formData.append("p_id", atob(props.match.params.id))
          formData.append("document_name", values.document_name)
          formData.append("file", file)
          formData.append("fileName", fileName)
          const res = await postRequestByFormData(
            "add-property-document",
            formData,
          )

          if (res && res.code === 200) {
            handleLoadGetPropertyDocuments(PreferredLanguage)

            setAlertData(AlertData => ({
              ...AlertData,
              variant: "success",
              message: res.message,
            }))
          } else {
            setAlertData(AlertData => ({
              ...AlertData,
              variant: "error",
              message: res.message,
            }))
          }
          resetAlertData()

          validation1.setValues({
            document_name: "",
          })
          setFile()
          setFileName("")

          submit1.disabled = false
          submit1.textContent = "Add"

          setStandardModal1(false)
        }
      } catch (error) {
        console.error("Error : ", error)
      }
    },
  })

  const validation2 = useFormik({
    enableReinitialize: true,

    initialValues: {
      pd_id: "",
      document_name: "",
    },
    validationSchema: Yup.object({
      document_name: Yup.string().required("Please select document name"),
    }),
    onSubmit: async values => {
      try {
        let submit2 = document.getElementById("submit2")
        submit2.disabled = true
        submit2.textContent = "Processing..."
        const formData = new FormData()
        formData.append("pd_id", values.pd_id)
        formData.append("p_id", atob(props.match.params.id))
        formData.append("document_name", values.document_name)
        formData.append("lang", PreferredLanguage)
        const res = await postRequestByFormData(
          "update-property-document-details",
          formData,
        )

        if (res && res.code === 200) {
          handleLoadGetPropertyDocuments(PreferredLanguage)

          setAlertData(AlertData => ({
            ...AlertData,
            variant: "success",
            message: res.message,
          }))
        } else {
          setAlertData(AlertData => ({
            ...AlertData,
            variant: "error",
            message: res.message,
          }))
        }
        resetAlertData()

        submit2.disabled = false
        submit2.textContent = "Add"

        setStandardModal2(false)
      } catch (error) {
        console.error("Error : ", error)
      }
    },
  })

  const handleUploadDoc = async e => {
    if (fileName === "") {
      setAlertData(AlertData => ({
        ...AlertData,
        variant: "error",
        message: "Please select new document!",
      }))
      resetAlertData()

      return false
    } else {
      let submit3 = document.getElementById("submit3")
      submit3.disabled = true
      submit3.textContent = "Processing..."

      const formData = new FormData()
      formData.append("pd_id", validation2.values.pd_id)
      formData.append("p_id", atob(props.match.params.id))
      formData.append("file", file)
      formData.append("fileName", fileName)
      const res = await postRequestByFormData(
        "update-property-document",
        formData,
      )
      if (res && res.code === 200) {
        handleLoadGetPropertyDocuments(PreferredLanguage)

        setAlertData(AlertData => ({
          ...AlertData,
          variant: "success",
          message: res.message,
        }))
      } else {
        setAlertData(AlertData => ({
          ...AlertData,
          variant: "error",
          message: res.message,
        }))
      }
      resetAlertData()

      submit3.disabled = false
      submit3.textContent = "Upload"
    }
  }

  const handleDeleteDocument = async (pd_id, document) => {
    const jsonpar = JSON.stringify({
      pd_id: atob(pd_id),
      p_id: atob(props.match.params.id),
      document: document,
    })
    const res = await postRequest("delete-property-document", jsonpar)
    if (res && res.code === 200) {
      handleLoadGetPropertyDocuments(PreferredLanguage)

      setAlertData(AlertData => ({
        ...AlertData,
        variant: "success",
        message: res.message,
      }))
    } else {
      setAlertData(AlertData => ({
        ...AlertData,
        variant: "error",
        message: res.message,
      }))
    }
    resetAlertData()
  }

  const [StandardModal1, setStandardModal1] = React.useState(false)
  const togStandardModal1 = async () => {
    setStandardModal1(true)
  }
  const [StandardModalDelete, setStandardModalDelete] = React.useState(false);
  const [deleteDocumentData, setDeleteDocumentData] = React.useState(null);
  const togStandardModalDelete = (documentData) => {
    setDeleteDocumentData(documentData);
    setStandardModalDelete(true);
  };
  const handleConfirmDelete = async () => {
    if (deleteDocumentData) {
      const res = await handleDeleteDocument(
        btoa(deleteDocumentData.pd_id),
        deleteDocumentData.document
      );
      setStandardModalDelete(false); 
    }
  };
  

  const [PropertiesTBody, setPropertiesTBody] = React.useState("")
  const handleT1Body = async (tempData, lang) => {
    let tempTBody = tempData.documents.map((element, index) => (
      <tr key={index}>
        <td>{index + 1}</td>
        <td>
          <a
            href={
              process.env.REACT_APP_API_URL + tempData.url + element.document
            }
            target="_blank"
            rel="noopener noreferrer"
          >
            <i></i>
            <span>
              {lang == "en" ? element.document_name : element.document_name_sp}
            </span>
          </a>
        </td>
        <td className="text-center">
          <div className="centerLink">
            <Link
              title="Edit Document"
              to="#"
              className="font-size-14 bg-primary edit-box"
              onClick={e => togStandardModal2(element, lang)}
            >
              <i className="bx bxs-edit"></i>
            </Link>
            <Link
              title="Delete Document"
              to={"#" + btoa(element.pd_id)}
              className="font-size-14 bg-primary edit-box "
              onClick={() => togStandardModalDelete(element)}
            >
              <i className="fas fa-trash"></i>
            </Link>
          </div>
        </td>
      </tr>
    ))

    setPropertiesTBody(tempTBody)
  }
  const handleLoadGetPropertyDocuments = async lang => {
    const jsonpar = JSON.stringify({
      p_id: atob(props.match.params.id),
    })
    const res = await postRequest("get-property-documents", jsonpar)

    if (res && res.code === 200) {
      let originalText = res.data
      handleT1Body(originalText, lang)
    } else {
      let tempTBody = (
        <tr>
          <td colSpan="5" className="text-center">
            No records found
          </td>
        </tr>
      )

      setPropertiesTBody(tempTBody)

      setAlertData(AlertData => ({
        ...AlertData,
        variant: "error",
        message: res.message,
      }))
    }
    resetAlertData()
  }

  const [StandardModal2, setStandardModal2] = React.useState(false)
  const togStandardModal2 = async (elementData, lang) => {
    let document_name = elementData.document_name
    if (lang !== "en") {
      document_name = elementData.document_name_sp
    }
    validation2.setValues({
      ...validation2.values,
      pd_id: elementData.pd_id,
      document_name: document_name,
    })
    setStandardModal2(true)
  }

  const [file, setFile] = useState()
  const [fileName, setFileName] = useState("")
  const saveFile = e => {
    if (e.target.files.length > 0) {
      setFile(e.target.files[0])
      setFileName(e.target.files[0].name)
    }
  }

  const [PreferredLanguage, setPreferredLanguage] = React.useState("en")
  const onChangePreferredLanguage = e => {
    setPreferredLanguage(e.target.value)
    handleLoadGetPropertyDocuments(e.target.value)
  }

  React.useEffect(() => {
    handleLoadGetPropertyDocuments("en")

    if (
      typeof location.state !== "undefined" &&
      typeof location.state.message !== "undefined"
    ) {
      setAlertData(AlertData => ({
        ...AlertData,
        variant: location.state.status,
        message: location.state.message,
      }))
      resetAlertData()
    }
  }, [])

  return (
    <React.Fragment>
      {AlertData.message !== "" ? (
        <Snackbars variant={AlertData.variant} message={AlertData.message} />
      ) : (
        ""
      )}
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs
            title={props.t("Eshepay")}
            breadcrumbItem={props.t("Documents")}
          />
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <Col xs="12" className="mb-2 cstm-fullWidth">
                    <Link className="back-link-2" to="/property"><i className="bx bx-left-arrow-alt"></i> Back</Link>
                    <div className="add-form">
                      <button
                        type="button"
                        onClick={e => togStandardModal1()}
                        className="btn btn-primary"
                      >
                        Add Document
                      </button>
                    </div>
                    <div className="lang-select">
                      <select
                        className="form-select top-right-lang"
                        name="preferred_language"
                        value={PreferredLanguage}
                        onChange={e => onChangePreferredLanguage(e)}
                      >
                        <option value={"en"}>English</option>
                        <option value={"sp"}>Spanish</option>
                      </select>
                      <i className="fas fa-angle-down"></i>
                    </div>
                  </Col>
                  <div className="table-rep-plugin cstm-fullWidth">
                    <div className="table-responsive">
                      <table
                        className="table table-hover table-highlight"
                        style={{ minWidth: "800px" }}
                      >
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Document</th>
                            <th className="text-center">Actions</th>
                          </tr>
                        </thead>
                        <tbody>{PropertiesTBody}</tbody>
                      </table>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      <Modal
        isOpen={StandardModal1}
        backdrop={"static"}
        centered
        className="transation"
      >
        <div>
          <div className="modal-header">
            <h5 className="modal-title mt-0">Add Document</h5>
            <button
              type="button"
              onClick={e => setStandardModal1(false)}
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <ModalBody>
            <div className="mb-3">
              <label className="form-label">Select Document : </label>
              <div className="input-group">
                <input
                  type="file"
                  className="form-control fileUpload"
                  aria-describedby="submit3"
                  aria-label="Upload"
                  accept=".pdf, .doc, .docx, .xls, .xlsx, .txt"
                  onChange={saveFile}
                />
              </div>
            </div>
            <div className="mb-3">
              <label className="form-label">Document Name :</label>
              <Input
                name="document_name"
                type="text"
                placeholder={"Document Name"}
                onChange={e =>
                  validation1.setValues({
                    ...validation1.values,
                    document_name: e.target.value,
                  })
                }
                onBlur={validation1.handleBlur}
                value={validation1.values.document_name || ""}
                invalid={
                  validation1.touched.document_name &&
                  validation1.errors.document_name
                    ? true
                    : false
                }
              />
              {validation1.touched.document_name &&
              validation1.errors.document_name ? (
                <FormFeedback type="invalid">
                  {validation1.errors.document_name}
                </FormFeedback>
              ) : null}
            </div>
          </ModalBody>
          <ModalFooter>
            <Button
              id="submit1"
              onClick={e => {
                e.preventDefault()
                validation1.handleSubmit()
                return false
              }}
              type="button"
              color="primary"
            >
              Add
            </Button>
            <Button
              type="button"
              color="light"
              onClick={e => setStandardModal1(false)}
            >
              Cancel
            </Button>
          </ModalFooter>
        </div>
      </Modal>

      <Modal
        isOpen={StandardModal2}
        backdrop={"static"}
        centered
        className="transation"
      >
        <div>
          <div className="modal-header">
            <h5 className="modal-title mt-0">Update Document</h5>
            <button
              type="button"
              onClick={() => setStandardModal2(false)}
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <ModalBody>
            <div className="mb-3">
              <label className="form-label mt-3">Select New Document:</label>
              <div className="input-group">
                <input
                  type="file"
                  className="form-control fileUpload"
                  aria-describedby="submit3"
                  aria-label="Upload"
                  accept=".pdf, .doc, .docx, .xls, .xlsx, .txt"
                  onChange={saveFile}
                />
                <button
                  className="btn btn-primary fileUpload"
                  type="button"
                  id="submit3"
                  onClick={e => handleUploadDoc()}
                >
                  Upload
                </button>
              </div>
            </div>
            <div className="mb-3">
              <label className="form-label">Document Name:</label>
              <Input
                name="document_name"
                type="text"
                placeholder={"Document Name"}
                onChange={e =>
                  validation2.setValues({
                    ...validation2.values,
                    document_name: e.target.value,
                  })
                }
                onBlur={validation2.handleBlur}
                value={validation2.values.document_name || ""}
                invalid={
                  validation2.touched.document_name &&
                  validation2.errors.document_name
                    ? true
                    : false
                }
              />
              {validation2.touched.document_name &&
              validation2.errors.document_name ? (
                <FormFeedback type="invalid">
                  {validation2.errors.document_name}
                </FormFeedback>
              ) : null}
            </div>
          </ModalBody>
          <ModalFooter>
            <Button
              id="submit2"
              onClick={e => {
                e.preventDefault()
                validation2.handleSubmit()
                return false
              }}
              type="button"
              color="primary"
            >
              Update
            </Button>
            <Button
              type="button"
              color="light"
              onClick={() => setStandardModal2(false)}
            >
              Cancel
            </Button>
          </ModalFooter>
        </div>
      </Modal>
      <Modal
          isOpen={StandardModalDelete}
          backdrop={"static"}
          centered
          className="transation"
        >
          <div>
            <div className="modal-header">
              <h5 className="modal-title mt-0">Confirm Delete</h5>
              <button
                type="button"
                onClick={() => setStandardModalDelete(false)}
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <ModalBody>
              <p>Are you sure you want to delete this document?</p>
              <p><strong>{deleteDocumentData ? deleteDocumentData.document_name : ''}</strong></p>
            </ModalBody>
            <ModalFooter>
              <Button
                color="danger"
                onClick={handleConfirmDelete}
              >
                Delete
              </Button>
              <Button
                type="button"
                color="light"
                onClick={() => setStandardModalDelete(false)}
              >
                Cancel
              </Button>
            </ModalFooter>
          </div>
      </Modal>
    </React.Fragment>
  )
}

export default withTranslation()(Property_Documents)
